/* eslint-disable react/jsx-curly-brace-presence */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// component
import CommonModal from "../../modal/CommonModal";

// API
import { getEduGoalFromMomthera, getEduGoalImgFromMomthera, getEduStatusFromMomthera } from "../../../services/apis/momthera/edu";
import { getAutothinkSessionWeek1FromMomthera, getAutothinkSessionWeek2FromMomthera, getAutothinkSessionWeek3FromMomthera, getAutothinkSessionWeek4FromMomthera } from "../../../services/apis/momthera/autothink";
import { getEmotionRecordImageFromMomthera, getEmotionRecordLostFromMomthera } from "../../../services/apis/momthera/emotion";
import { getDecisionReasonImageFromMomthera, getDecisionReasonMemoFromMomthera } from "../../../services/apis/momthera/decision";
import getMyReviewsFromMomthera from "../../../services/apis/momthera/review";
import getBaseCodeFromMomthera from "../../../services/apis/momthera/base";
import { getGroundingCalmingFromMomthera, getGroundingComfortableFromMomthera } from "../../../services/apis/momthera/grounding";
import { getActivitiesAssessmentFromMomthera, getActivitiesDetailFromMomthera, getActivitiesFromMomthera } from "../../../services/apis/momthera/activity";
import getOvercomeFromMomthera from "../../../services/apis/momthera/overcome";
import getLetterFromMomthera from "../../../services/apis/momthera/letter";
import getResponsePlanFromMomthera from "../../../services/apis/momthera/responsePlan";


const TABLE_HEADER = [
    {
        key: 'theraTypeName',
        name: '기법'
    },
    {
        key: 'theraTypeSubtopic',
        name: '세부주제'
    },
    {
        key: 'learningCnt',
        name: '횟수'
    },
    {
        key: 'studyTime',
        name: '시간'
    },
    {
        key: 'status',
        name: '상태'
    },
    {
        key: 'content',
        name: '교육 내용'
    }
]

function convertDepressionScore(score){
    if(score<=8) return "정상";
    else if(score<=12) return "경계선 ~ 상담 필요";
    else return "산후우울증 의심"
}

function convertAnxietyScore(score){
    if(score<=4) return "정상";
    else if(score<=9) return "가벼운 수준의 불안";
    else if(score<=14) return "중간 수준의 불안";
    else return "심한 수준의 불안"
}

function convertEduStatus(status){
    if(status==="COMPLETE") return "완료";
    else if(status==="IN_PROGRESS") return "진행중";
    else return "미진행";
}

function convertAtivityDateToDay(YYYYMMDD){
    try{
        const dateString = `${YYYYMMDD.slice(0,4)}-${YYYYMMDD.slice(4,6)}-${YYYYMMDD.slice(6)}`;
        const date = new Date(dateString);
        return ['일','월','화','수','목','금','토'][date.getDay()];
    }catch{
        return "";
    }
}

function ActivityRecordEmotion({type="", emotionScore=0}){
    return (
        <div className={`monthera_activityRecord_emotion_box ${type==='eduGoal' ? "eduGoal" : ""}`}> 
            <div className="label_wrapper">
                {new Array(10).fill(0).map((_,idx)=>(
                    <div key={idx} className="label_item">
                        <span>{idx+1}</span>
                    </div>
                ))}
            </div>
            <div className="score_box">
                <div className="graph_wrapper">
                    {new Array(9).fill(0).map((_,idx)=>(
                        <div key={idx} className="graph_divider" />
                    ))}
                </div>
            </div>
            {Boolean(emotionScore) && <div className="score_bar" style={{width: `calc(${100 / 9 * (emotionScore - 1)}%)`}} />}
        </div>
    )
}

function Week1Section({depressionScoreWeek1, anxietyScoreWeek1, emotionListWeek1}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[현재 상태 점검] 우울 및 불안 점수</div>
                <div className="content">
                    <div className="content_row">
                        <span>우울 점수</span>
                        <span>{(Boolean(depressionScoreWeek1) || depressionScoreWeek1===0)  ? `${convertDepressionScore(depressionScoreWeek1)} (${depressionScoreWeek1} 점)` : ""}</span>                              
                    </div>
                    <div className="content_row">
                        <span>불안 점수</span>
                        <span>{(Boolean(anxietyScoreWeek1) || anxietyScoreWeek1===0) ? `${convertAnxietyScore(anxietyScoreWeek1)} (${anxietyScoreWeek1} 점)` : ""}</span>
                    </div>
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[마무리하기] 감정 기록</div>
                <div className="content">
                    {emotionListWeek1.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
        </div>
    )
}

function Week2Section({emotionListWeek2, comfortableWeek2}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[기분 상태 점검] 감정 기록</div>
                <div className="content">
                    {emotionListWeek2.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[신체적 그라운딩] 가장 편안하다고 느낀 방법</div>
                <div className="content">
                    <div className="center">{comfortableWeek2}</div>
                </div>                        
            </div>
        </div>
    )
}

function Week3Section({emotionListWeek3, comfortableWeek3}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[기분 상태 점검] 감정 기록</div>
                <div className="content">
                    {emotionListWeek3.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[진정형 그라운딩] 가장 편안하다고 느낀 방법</div>
                <div className="content">
                    <div className="center">{comfortableWeek3}</div>
                </div>                        
            </div>
        </div>
    )
}

function Week4Section({emotionListWeek4, depressionScoreWeek4, anxietyScoreWeek4, comfortableWeek4}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[기분 상태 점검] 감정 기록</div>
                <div className="content">
                    {emotionListWeek4.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[점진적 근육 이완법] 가장 편안하다고 느낀 방법</div>
                <div className="content">
                    <div className="center">{comfortableWeek4}</div>
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[마무리하기] 우울 및 불안 점수</div>
                <div className="content">
                    <div className="content_row">
                        <span>우울 점수</span>
                        <span>{(Boolean(anxietyScoreWeek4) || anxietyScoreWeek4===0) ? `${convertDepressionScore(depressionScoreWeek4)} (${depressionScoreWeek4} 점)` : ""}</span>                              
                    </div>
                    <div className="content_row">
                        <span>불안 점수</span>
                        <span>{(Boolean(anxietyScoreWeek4) || anxietyScoreWeek4===0) ? `${convertAnxietyScore(anxietyScoreWeek4)} (${anxietyScoreWeek4} 점)` : ""}</span>
                    </div>
                </div>                        
            </div>
        </div>
    )
}

function Week5Section({emotionListWeek5, comfortableWeek5}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[기분 상태 점검] 감정 기록</div>
                <div className="content">
                    {emotionListWeek5.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[주산기산모 요가] 가장 편안하다고 느낀 방법</div>
                <div className="content">
                    <div className="center">{comfortableWeek5}</div>
                </div>                        
            </div>
        </div>
    )
}

function Week6Section({emotionListWeek6, comfortableWeek6}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[기분 상태 점검] 감정 기록</div>
                <div className="content">
                    {emotionListWeek6.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[걷기 마음챙김] 가장 편안하다고 느낀 방법</div>
                <div className="content">
                    <div className="center">{comfortableWeek6}</div>
                </div>                        
            </div>
        </div>
    )
}

function Week7Section({emotionListWeek7, comfortableWeek7}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[기분 상태 점검] 감정 기록</div>
                <div className="content">
                    {emotionListWeek7.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[내 마음 속 안전장소 만들기] 가장 편안하다고 느낀 방법</div>
                <div className="content">
                    <div className="center">{comfortableWeek7}</div>
                </div>                        
            </div>
        </div>
    )
}

function Week8Section({emotionListWeek8, depressionScoreWeek8, anxietyScoreWeek8}) {
    return (
        <div className="momthera_education_left_section">
            <div className="momthera_education_left_box">
                <div className="title">[기분 상태 점검] 감정 기록</div>
                <div className="content">
                    {emotionListWeek8.map(emotion => (
                        <div key={emotion.emotionCode} className="content_row">
                            <span>{emotion.emotionName}</span>
                            <span>{emotion.score} / 100 점</span>
                        </div>
                    ))}
                </div>                        
            </div>
            <div className="momthera_education_left_box">
                <div className="title">[마무리하기] 우울 및 불안 점수</div>
                <div className="content">
                    <div className="content_row">
                        <span>우울 점수</span>
                        <span>{(Boolean(depressionScoreWeek8) || depressionScoreWeek8===0) ? `${convertDepressionScore(depressionScoreWeek8)} (${depressionScoreWeek8} 점)` : ""}</span>                              
                    </div>
                    <div className="content_row">
                        <span>불안 점수</span>
                        <span>{(Boolean(anxietyScoreWeek8) || anxietyScoreWeek8===0) ? `${convertAnxietyScore(anxietyScoreWeek8)} (${anxietyScoreWeek8} 점)` : ""}</span>
                    </div>
                </div>                        
            </div>
        </div>
    )
}

function MomtheraEducation({patientData, emotionData, depressionData, anxietyData}) {
    const { pid } = useParams();

    /* 1주차 데이터 */
    const [depressionScoreWeek1, setDepressionScoreWeek1] = useState(null) // 우울 점수
    const [anxietyScoreWeek1, setAnxietyScoreWeek1] = useState(null) // 불안 점수
    const [emotionListWeek1, setEmotionListWeek1] = useState([]); // 감정 리스트
    const [emotionMemoWeek1, setEmotionMemoWeek1] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek1, setEmotionImgWeek1] = useState(""); // 감정 기록지 사진
    const [autothinkWeek1, setAutothinkWeek1] = useState({situation: "", think: "", result: ""}); // 자동사고 기록지
    const [reviewListWeek1, setReviewListWeek1] = useState([{memo: "", secretMode: false, date: ""}]); // 후기
    /* 2주차 데이터 */
    const [emotionListWeek2, setEmotionListWeek2] = useState([]); // 감정 리스트
    const [emotionMemoWeek2, setEmotionMemoWeek2] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek2, setEmotionImgWeek2] = useState(""); // 감정 기록지 사진
    const [autothinkWeek2, setAutothinkWeek2] = useState({situation: "", autoThinking: "", distortionCode: "", emotion: []}); // 자동사고 기록지
    const [reviewListWeek2, setReviewListWeek2] = useState([{memo: "", secretMode: false, date: ""}]); // 후기
    const [comfortableWeek2, setComfortableWeek2] = useState("");
    /* 3주차 데이터 */
    const [emotionListWeek3, setEmotionListWeek3] = useState([]); // 감정 리스트
    const [emotionMemoWeek3, setEmotionMemoWeek3] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek3, setEmotionImgWeek3] = useState(""); // 감정 기록지 사진
    const [autothinkWeek3, setAutothinkWeek3] = useState({situation: "", autoThinking: "", distortionCode: "", emotion: [], evaluation: ""}); // 자동사고 기록지
    const [reviewListWeek3, setReviewListWeek3] = useState([{memo: "", secretMode: false, date: ""}]); // 후기
    const [comfortableWeek3, setComfortableWeek3] = useState("");
    /* 4주차 데이터 */
    const [emotionListWeek4, setEmotionListWeek4] = useState([]); // 감정 리스트
    const [emotionMemoWeek4, setEmotionMemoWeek4] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek4, setEmotionImgWeek4] = useState(""); // 감정 기록지 사진
    const [depressionScoreWeek4, setDepressionScoreWeek4] = useState(null) // 우울 점수
    const [anxietyScoreWeek4, setAnxietyScoreWeek4] = useState(null) // 불안 점수
    const [autothinkWeek4, setAutothinkWeek4] = useState({distortion: []}); // 자동사고 기록지
    const [reviewListWeek4, setReviewListWeek4] = useState([{memo: "", secretMode: false, date: ""}]); // 후기
    const [comfortableWeek4, setComfortableWeek4] = useState("");
    /* 5주차 데이터 */
    const [emotionListWeek5, setEmotionListWeek5] = useState([]); // 감정 리스트
    const [emotionMemoWeek5, setEmotionMemoWeek5] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek5, setEmotionImgWeek5] = useState(""); // 감정 기록지 사진
    const [activityDetailWeek5, setActivityDetailWeek5] = useState(null); // 구체화한 활동
    const [reviewListWeek5, setReviewListWeek5] = useState([{memo: "", secretMode: false, date: ""}]); // 후기
    const [comfortableWeek5, setComfortableWeek5] = useState("");
    /* 6주차 데이터 */
    const [emotionListWeek6, setEmotionListWeek6] = useState([]); // 감정 리스트
    const [emotionMemoWeek6, setEmotionMemoWeek6] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek6, setEmotionImgWeek6] = useState(""); // 감정 기록지 사진
    const [activityDetailWeek6, setActivityDetailWeek6] = useState(null); // 구체화한 활동
    const [reviewListWeek6, setReviewListWeek6] = useState([{memo: "", secretMode: false, date: ""}]); // 후기
    const [comfortableWeek6, setComfortableWeek6] = useState("");
    /* 7주차 데이터 */
    const [emotionListWeek7, setEmotionListWeek7] = useState([]); // 감정 리스트
    const [emotionMemoWeek7, setEmotionMemoWeek7] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek7, setEmotionImgWeek7] = useState(""); // 감정 기록지 사진
    const [reviewListWeek7, setReviewListWeek7] = useState([{memo: "", secretMode: false, date: ""}]); // 후기
    const [comfortableWeek7, setComfortableWeek7] = useState("");
    /* 8주차 데이터 */
    const [emotionListWeek8, setEmotionListWeek8] = useState([]); // 감정 리스트
    const [emotionMemoWeek8, setEmotionMemoWeek8] = useState(""); // 감정 기록지 메모
    const [emotionImgWeek8, setEmotionImgWeek8] = useState(""); // 감정 기록지 사진
    const [depressionScoreWeek8, setDepressionScoreWeek8] = useState(null) // 우울 점수
    const [anxietyScoreWeek8, setAnxietyScoreWeek8] = useState(null) // 불안 점수
    const [reviewListWeek8, setReviewListWeek8] = useState([{memo: "", secretMode: false, date: ""}]); // 후기


    const [overcome, setOvercome] = useState(""); // 우울을 극복하기 위한 방법
    
    const [groundingCalm, setGroundingCalm] = useState(""); // 진정형 그라운딩

    const [decisionMemo, setDecisionMemo] = useState("") // 치료를 결심하게 된 이유 메모
    const [decisionImg, setDecisionImg] = useState("") // 치료를 결심하게 된 이유 사진
    
    const [eduStatusData, setEduStatusData] = useState([]); // 주차별 교육 현황

    const [onGoingSession, setOnGoingSession] = useState(0); // 진행 중인 세션
    const [selectedSession, setSelectedSession] = useState(1); // 현재 선택한 세션

    const [emotionBase, setEmotionBase] = useState([]); // 감정 종류
    const [distortionBase, setDistortionBase] = useState([]); // 인지왜곡 종류

    const [eduGoal, setEduGoal] = useState({goal: "", emotionLevel: 0}); // 치료 목표
    const [eduGoalImg, setEduGoalImg] = useState(null); // 치료 목표 이미지

    const [acitivities, setAcitivities] = useState({levelOne: [], levelTwo: [], levelThree: []}) // 행동 목록

    const [assessment, setAssessment] = useState({
        positiveActivities: [],
        sustainingFactors: [],
        vulnerableSituations: [],
        negativeBehaviors: []
    }); // 사용자 활동 평가

    const [lostEmotion, setLostEmotion] = useState([]); // 사라지거나 줄어든 감정

    const [letter, setLetter] = useState({content: "", commitmentPlan: ""}); // 편지

    const [responsePlan, setResponsePlan] = useState({theraTypeName: "", theraTypeSubtopicName: "", userPlan: ""}); // 대처방안

    
    // 감정 종류 조회
    async function getEmotionBaseFromAPI() {
        try{
            const res = await getBaseCodeFromMomthera({codeGrp: 110});
            if(Math.floor(res.status/100)===2){
                setEmotionBase(res.data);
            }else{
                throw new Error();
            }
        }catch{
            setEmotionBase([]);
        }
    }
    // 감정 code로 name 조회
    function searchEmotionName({targetCode}){
        try{
            const name = emotionBase.find(e=>e.code===targetCode).val1;
            return name;
        }catch{
            return ""
        }
    }

    // 인지왜곡 종류 조회
    async function getDistortionBaseFromAPI() {
        try{
            const res = await getBaseCodeFromMomthera({codeGrp: 50});
            if(Math.floor(res.status/100)===2){
                setDistortionBase(res.data);
            }else{
                throw new Error();
            }
        }catch{
            setDistortionBase([]);
        }
    }
    // 인지왜곡 code로 name 조회
    function searchDistortionName({targetCode}){
        try{
            const name = distortionBase.find(e=>e.code===targetCode).val1;
            return name;
        }catch{
            return "";
        }
    }

    // 활동 code로 reason 조회
    function searchActivityReason({targetCode}){
        try{
            const activityAll = [...acitivities.levelOne, ...acitivities.levelTwo, ...acitivities.levelThree];
            const {reason} = activityAll.find(e=>e.activityCode===targetCode);
            return reason;
        }catch{
            return "";
        }
    }

    // 주차별 교육 현황 조회
    async function getEduStatusFromAPI({sessionNum}){
        try{
            const request = {
                pid, 
                'session-num': sessionNum
            };
            const res = await getEduStatusFromMomthera(request);
            if(Math.floor(res.status/100)===2 && res.data.length>0){
                setEduStatusData(res.data);
            }else{
                setEduStatusData([]);
            }
        }catch{
            setEduStatusData([]);
        }
    }

    // 감정 리스트 매핑
    function mappingEmotionList(targetSession, setState) {
        try{
            const newEmotionList = emotionData.find(e=>e.sessionNum===targetSession).emotionInfoList;
            setState(newEmotionList);
        }catch{
            setState([]);
        }
    }
    // 감정 메모 매핑
    function mappingEmotionMemo(targetSession, setState) {
        try{
            const emotionMemo = emotionData.find(e=>e.sessionNum===targetSession).memo;
            setState(emotionMemo);
        }catch{
            setState("");
        }
    }
    // 우울 검사 매핑
    function mappingDepressionScore(targetSession, setState) {
        try{
            const depressionScore = depressionData.find(e=>e.sessionNum===targetSession).totalScore;
            setState(depressionScore);
        }catch{
            setState(null);
        }
    }
    // 불안 검사 매핑
    function mappingAnxietyScore(targetSession, setState) {
        try{
            const anxietyScore = anxietyData.find(e=>e.sessionNum===targetSession).totalScore;
            setState(anxietyScore);
        }catch{
            setState(null);
        }
    }

    // 1회기 자동사고 기록지 조회
    async function getAutothinkSessionWeek1FromAPI(){
        try{
            const res = await getAutothinkSessionWeek1FromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setAutothinkWeek1(res.data);
            }else{
                throw new Error();
            }
        }catch{
            setAutothinkWeek1({situation: "", think: "", result: ""});
        }
    }
    // 2회기 자동사고 기록지 조회
    async function getAutothinkSessionWeek2FromAPI() {
        try{
            const res = await getAutothinkSessionWeek2FromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setAutothinkWeek2({
                    situation: res.data.situation,
                    autoThinking: res.data.autoThinking,
                    distortionCode: res.data.distortionCode,
                    emotion: res.data.autoThinkEmotionResList
                })
            }else{
                throw new Error();
            }
        }catch{
            setAutothinkWeek2({situation: "", autoThinking: "", distortionCode: "", emotion: []})
        }
    }
    // 3회기 자동사고 기록지 조회
    async function getAutothinkSessionWeek3FromAPI() {
        try{
            const res = await getAutothinkSessionWeek3FromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setAutothinkWeek3({
                    situation: res.data.situation,
                    autoThinking: res.data.autoThinking,
                    emotion: res.data.autoThinkEmotionResList,
                    evaluation: res.data.autoThinkingResult
                })
            }else{
                throw new Error();
            }
        }catch{
            setAutothinkWeek3({situation: "", autoThinking: "", evaluation: "", emotion: []})
        }
    }
    // 4회기 자동사고 기록지 조회
    async function getAutothinkSessionWeek4FromAPI() {
        try{
            const res = await getAutothinkSessionWeek4FromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setAutothinkWeek4({
                    distortion: res.data.otherDistortionList
                })
            }else{
                throw new Error();
            }
        }catch{
            setAutothinkWeek4({distortion: []})
        }
    }

    // 후기 조회
    async function getReviewFromAPI(targetSession, setState) {
        try {
            const res = await getMyReviewsFromMomthera({sessionNum: targetSession, pid});
            if(Math.floor(res.status/100)===2 && res.data.length>0){
                const newReview = res.data[0].mainReviewMemoList.map(e=>({
                    memo: e.memo || "",
                    secretMode: e.secretMode || false,
                    date: e.insDate || ""
                }))
                setState(newReview);
            }else{
                throw new Error();
            }
        }catch{
            setState([{memo: "", secretMode: false, insDate: ""}]);
        }
    }

    // 감정 기록지 이미지 조회
    async function getEmotionImgFromAPI({sessionNum, setState}) {
        try{
            const res = await getEmotionRecordImageFromMomthera({sessionNum, pid});
            if(Math.floor(res.status/100)===2 && res.data){
                const imgFile = res.data;
                const imgUrl = URL.createObjectURL(imgFile);
                setState(imgUrl);
            }else{
                throw new Error()
            }
        }catch{
            setState(null);
        }
    }

    // 치료를 결심한 이유(메모) 조회
    async function getDecisionReasonMemoFromAPI() {
        try{
            const res = await getDecisionReasonMemoFromMomthera({pid});
            if(Math.floor(res.status/100)===2 && res.data.memo){
                setDecisionMemo(res.data.memo);
            }else{
                throw new Error();
            }
        }catch{
            setDecisionMemo("");
        }
    }

    // 치료를 결심한 이유(사진) 조회
    async function getDecisionReasonImageFromAPI() {
        try{
            const res = await getDecisionReasonImageFromMomthera({pid});
            if(Math.floor(res.status/100)===2 && res.data){
                const blob = res.data;
                const url = URL.createObjectURL(blob);
                setDecisionImg(url);
            }else{
                throw new Error();
            }
        }catch{
            setDecisionImg(null);
        }
    }

    // 진정형 그라운딩 조회
    async function getGroundingCalmFromAPI() {
        try{
            const res = await getGroundingCalmingFromMomthera({pid});
            if(Math.floor(res.status/100)===2 && res.data.content){
                setGroundingCalm(res.data.content);
            }else{
                throw new Error();
            }
        }catch{
            setGroundingCalm("");
        }
    }

    // 치료 목표 조회
    async function getEduGoalFromAPI() {
        try {
            const res = await getEduGoalFromMomthera({pid});
            if(Math.floor(res.status/100)===2 && res.data.goal) {
                setEduGoal(res.data);
            }else{
                throw new Error();
            }
        }catch{
            setEduGoal({goal: "", emotionLevel: 0});
        }
    }

    // 치료 목표 이미지 조회
    async function getEduGoalImgFromAPI() {
        try{
            const res = await getEduGoalImgFromMomthera({pid});
            if(Math.floor(res.status/100)===2 && res.data){
                const blob = res.data;
                const url = URL.createObjectURL(blob);
                setEduGoalImg(url);
            }else{
                throw new Error();
            }
        }catch{
            setEduGoalImg(null);
        }
    }

    // 행동 목록 조회
    async function getActivitiesFromAPI() {
        try{
            const res = await getActivitiesFromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setAcitivities({
                    levelOne: res.data.levelOne,
                    levelTwo: res.data.levelTwo,
                    levelThree: res.data.levelThree
                })
            }else{
                throw new Error();
            }
        }catch{
            setAcitivities({levelOne: [], levelTwo: [], levelThree: []});
        }
    }

    // 구체화한 활동 조회
    async function getActivityDetailFromAPI({targetSession, setState}) {
        try{
            const res = await getActivitiesDetailFromMomthera({pid, sessionNum: targetSession});
            if(Math.floor(res.status/100)===2 && res.data.activityCode){
                setState(res.data);
            }else{
                throw new Error();
            }
        }catch{
            setState(null);
        }
    }

    // 우울 극복 방법 조회
    async function getOvercomeFromAPI() {
        try{
            const res = await getOvercomeFromMomthera({pid});
            if(Math.floor(res.status/100)===2 && res.data.content){
                setOvercome(res.data.content);
            }else{
                throw new Error();
            }
        }catch{
            setOvercome("");
        }
    }

    // 사용자 활동 평가 조회
    async function getActivitiesAssessmentFromAPI() {
        try{
            const res = await getActivitiesAssessmentFromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setAssessment({
                    positiveActivities: res.data.positiveActivities || [],
                    sustainingFactors: res.data.sustainingFactors || [],
                    vulnerableSituations: res.data.vulnerableSituations || [],
                    negativeBehaviors: res.data.negativeBehaviors || []
                })
            }else{
                throw new Error();
            }
        }catch{
            setAssessment({positiveActivities: [], sustainingFactors: [], vulnerableSituations: [], negativeBehaviors: []})
        }
    }

    // 사라지거나 줄어든 감정 조회
    async function getLostEmotionFromAPI() {
        try{
            const res = await getEmotionRecordLostFromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setLostEmotion(res.data[0].emotionInfoList.map(e=>e.emotionName));
            }else{
                throw new Error();
            }
        }catch{
            setLostEmotion([]);
        }
    }

    // 편지 조회
    async function getLetterFromAPI() {
        try{
            const res = await getLetterFromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setLetter({
                    content: res.data.content || "",
                    commitmentPlan: res.data.commitmentPlan || ""
                })
            }else{
                throw new Error();
            }
        }catch{
            setLetter({content: "", commitmentPlan: ""});
        }
    }

    // 대처방안 조회
    async function getResponsePlanFromAPI() {
        try{
            const res = await getResponsePlanFromMomthera({pid});
            if(Math.floor(res.status/100)===2){
                setResponsePlan({
                    theraTypeName: res.data.theraTypeName,
                    theraTypeSubtopicName: res.data.theraTypeSubtopicName,
                    userPlan: res.data.userPlan
                })
            }
        }catch{
            setResponsePlan({theraTypeName: "", theraTypeSubtopicName: "", userPlan: ""});
        }
    }

    // 주차별 가장 편안하다고 느낀 방법 조회
    async function getGroundingComfortableFromAPI({targetSession, setState}) {
        try {
            const res = await getGroundingComfortableFromMomthera({pid, sessionNum: targetSession});
            if(Math.floor(res.status/100)===2 && res.data){
                setState(res.data);
            }else{
                throw new Error();
            }
        }catch{
            setState("");
        }
    }

    // Week1Edu03
    const [showWeek1Edu03, setShowWeek1Edu03] = useState(false);

    const closeWeek1Edu03 = () => {
        setShowWeek1Edu03(false);
    }

    const Week1Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">우울 및 불안 점수</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">우울 점수</div>
                    {(Boolean(depressionScoreWeek1) || depressionScoreWeek1===0) && (
                        <div className="box space bold_text">
                            <span>{convertDepressionScore(depressionScoreWeek1)}</span>
                            <span>{depressionScoreWeek1} 점</span>
                        </div>
                    )}
                </div>
                <div className="column">
                    <div className="subtitle">불안 점수</div>
                    {(Boolean(anxietyScoreWeek1) || anxietyScoreWeek1===0) && (
                        <div className="box space bold_text">
                            <span>{convertAnxietyScore(anxietyScoreWeek1)}</span>
                            <span>{anxietyScoreWeek1} 점</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )

    const Week1Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek1Edu03}>닫기</button>
        </div>
    )

    // Week1Edu02
    const [showWeek1Edu02, setShowWeek1Edu02] = useState(false);

    const closeWeek1Edu02 = () => {
        setShowWeek1Edu02(false);
    }

    const Week1Edu02Body = (
        <div className="momthera_education_modal_body">
            <div className="title">자동사고 기록지 - 우울과 인지재구성</div>
            <div className="subtitle">어떤 상황이었나요?</div>
            <div className="box">
                {autothinkWeek1 && autothinkWeek1.situation}
            </div>
            <div className="subtitle">그 순간 어떤 생각이 들었나요?</div>
            <div className="box">
                {autothinkWeek1 && autothinkWeek1.autoThinking}
            </div>
            <div className="subtitle">어떤 결과로 이어졌나요?</div>
            <div className="box">
                {autothinkWeek1 && autothinkWeek1.autoThinkingResult}
            </div>
        </div>
    )

    const Week1Edu02Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek1Edu02}>닫기</button>
        </div>
    )

    // Week1Edu06
    const [showWeek1Edu06, setShowWeek1Edu06] = useState(false);

    const closeWeek1Edu06 = () => {
        setShowWeek1Edu06(false);
    }

    const Week1Edu06Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek1.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek1}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek1 && <img className="fit_img" src={emotionImgWeek1} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
            <hr />
            <div className="title">치료를 결심하게 된 이유</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{decisionMemo}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {decisionImg && <img className="fit_img" src={decisionImg} alt="week1 edu06 decision"/>}
                    </div>
                </div>
            </div>
            <hr />
            <div className="subtitle">1주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek1 && reviewListWeek1.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week1Edu06Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek1Edu06}>닫기</button>
        </div>
    )

    // Week2Edu03
    const [showWeek2Edu03, setShowWeek2Edu03] = useState(false);

    const closeWeek2Edu03 = () => {
        setShowWeek2Edu03(false);
    }

    const Week2Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek2.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek2}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek2 && <img className="fit_img" src={emotionImgWeek2} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
        </div>
    )
    const Week2Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek2Edu03}>닫기</button>
        </div>
    )

    // Week2Edu02
    const [showWeek2Edu02, setShowWeek2Edu02] = useState(false);

    const closeWeek2Edu02 = () => {
        setShowWeek2Edu02(false);
    }

    const Week2Edu02Body = (
        <div className="momthera_education_modal_body">
            <div className="title">자동사고 기록지</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">감정(강도)</div>
                    <div className="box">
                        {autothinkWeek2 && autothinkWeek2.emotion.map(e=>(
                            <div key={e.emotionCode} className="halfBox" style={{width: '100%'}}>
                                <span>{searchEmotionName({targetCode: e.emotionCode})}</span>
                                <span>{e.emotionScore} / 100 점</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="column">
                    <div className="subtitle">인지왜곡</div>
                    <div className="box text-center">{searchDistortionName({targetCode: autothinkWeek2.distortionCode})}</div>
                </div>
            </div>
            <div className="subtitle">상황</div>
            <div className="box h-175">{autothinkWeek2.situation}</div>
            <div className="subtitle">자동적 사고</div>
            <div className="box h-175">{autothinkWeek2.autoThinking}</div>
        </div>
    )
    const Week2Edu02Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek2Edu02}>닫기</button>
        </div>
    )

    // Week2Edu06
    const [showWeek2Edu06, setShowWeek2Edu06] = useState(false);

    const closeWeek2Edu06 = () => {
        setShowWeek2Edu06(false);
    }

    const Week2Edu06Body = (
        <div className="momthera_education_modal_body">
            <div className="title">2주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek2 && reviewListWeek2.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week2Edu06Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek2Edu06}>닫기</button>
        </div>
    )

    // Week3Edu03
    const [showWeek3Edu03, setShowWeek3Edu03] = useState(false);

    const closeWeek3Edu03 = () => {
        setShowWeek3Edu03(false);
    }

    const Week3Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek3.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek3}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek3 && <img className="fit_img" src={emotionImgWeek3} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
        </div>
    )
    const Week3Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek3Edu03}>닫기</button>
        </div>
    )

    // Week3Edu01
    const [showWeek3Edu01, setShowWeek3Edu01] = useState(false);

    const closeWeek3Edu01 = () => {
        setShowWeek3Edu01(false);
    }

    const Week3Edu01Body = (
        <div className="momthera_education_modal_body">
            <div className="title">진정형 그라운딩 가이드 - {patientData.name} 님 만의 위로의 말</div>
            <div className="box">{groundingCalm}</div>
        </div>
    )
    const Week3Edu01Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek3Edu01}>닫기</button>
        </div>
    )

    // Week3Edu02
    const [showWeek3Edu02, setShowWeek3Edu02] = useState(false);

    const closeWeek3Edu02 = () => {
        setShowWeek3Edu02(false);
    }

    const Week3Edu02Body = (
        <div className="momthera_education_modal_body">
            <div className="title">자동사고 기록지</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">상황</div>
                    <div className="box">{autothinkWeek3.situation}</div>
                </div>
                <div className="column">
                    <div className="subtitle">감정(강도)</div>
                    <div className="box">
                        {autothinkWeek3 && autothinkWeek3.emotion.map(e=>(
                            <div key={e.emotionCode} className="halfBox" style={{width: '100%'}}>
                                <span>{searchEmotionName({targetCode: e.emotionCode})}</span>
                                <span>{e.emotionScore} / 100 점</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">자동적 사고</div>
                    <div className="box">
                        {autothinkWeek3.autoThinking}
                    </div>
                </div>
                <div className="column">
                    <div className="subtitle">자동적 사고 평가</div>
                    <div className="box">{autothinkWeek3.evaluation}</div>
                </div>
            </div>
        </div>
    )
    const Week3Edu02Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek3Edu02}>닫기</button>
        </div>
    )

    // Week3Edu06
    const [showWeek3Edu06, setShowWeek3Edu06] = useState(false);

    const closeWeek3Edu06 = () => {
        setShowWeek3Edu06(false);
    }

    const Week3Edu06Body = (
        <div className="momthera_education_modal_body">
            <div className="title">3주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek3 && reviewListWeek3.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week3Edu06Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek3Edu06}>닫기</button>
        </div>
    )

    // Week4Edu03
    const [showWeek4Edu03, setShowWeek4Edu03] = useState(false);

    const closeWeek4Edu03 = () => {
        setShowWeek4Edu03(false);
    }

    const Week4Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek4.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek4}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek4 && <img className="fit_img" src={emotionImgWeek4} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
        </div>
    )
    const Week4Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek4Edu03}>닫기</button>
        </div>
    )

    // Week4Edu02
    const [showWeek4Edu02, setShowWeek4Edu02] = useState(false);

    const closeWeek4Edu02 = () => {
        setShowWeek4Edu02(false);
    }

    const Week4Edu02Body = (
        <div className="momthera_education_modal_body">
            <div className="title">자동사고 기록지 - 인지왜곡 평가</div>
            <div className="subtitle">수민씨(예시)의 상황(자동사고 기록지)을 통해 평가한 인지왜곡</div>
            <div className="box" style={{marginBottom: '0.3125rem'}}>그렇게 생각할 때마다 아무에게도 이해받지 못하는 것 같아 괴롭고 서운하고 외롭다.</div>
            <div className="box" style={{marginBottom: '1.6875rem'}}>
                <div className="distortion_item">
                    <div className="distortion_name" />
                    <div className="distortion_check">
                        <div className="check_item">YES</div>
                        <div className="check_item">NO</div>                        
                    </div>
                </div>
                {autothinkWeek4 && autothinkWeek4.distortion.map(item => (
                    <div key={item.distortionCode} className="distortion_item">
                        <div className="distortion_name">{searchDistortionName({targetCode: item.distortionCode})}</div>
                        <div className="distortion_check">
                            <div className="check_item">
                                <input type="checkbox" checked={item.isChecked} onClick={()=>{}} readOnly />
                            </div>
                            <div className="check_item">
                                <input type="checkbox" checked={!item.isChecked} onClick={()=>{}} readOnly />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="title">수민씨(예시)의 상황(자동사고 기록지)</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">상황</div>
                    <div className="box h-175">친정 엄마가 전화 통화 중 복직을 미루라고 했다.</div>
                </div>
                <div className="column">
                    <div className="subtitle">자동적 사고</div>
                    <div className="box h-175">
                        엄마고 남편이고 아무도 나를 이해하지 못한다. 결국 다들 나한테 커리어를 포기하라고 하는 것이다.
                    </div>
                </div>
            </div>
            <div className="subtitle">감정(강도)</div>
            <div className="box flexRow">
                {[{emotionName: "분노", score: 90},{emotionName: "절망", score: 90}].map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="subtitle">인지왜곡</div>
            <div className="box">그렇게 생각할 때마다 아무에게도  이해받지 못하는 것 같아 괴롭고 서운하고 외롭다.</div>
        </div>
    )
    const Week4Edu02Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek4Edu02}>닫기</button>
        </div>
    )

    // Week4Edu06
    const [showWeek4Edu06, setShowWeek4Edu06] = useState(false);

    const closeWeek4Edu06 = () => {
        setShowWeek4Edu06(false);
    }

    const Week4Edu06Body = (
        <div className="momthera_education_modal_body">
            <div className="title">우울 및 불안 점수</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">우울 점수</div>
                    {(Boolean(depressionScoreWeek4) || depressionScoreWeek4===0) && (
                        <div className="box space bold_text">
                            <span>{convertDepressionScore(depressionScoreWeek4)}</span>
                            <span>{depressionScoreWeek4} 점</span>
                        </div>
                    )}
                </div>
                <div className="column">
                    <div className="subtitle">불안 점수</div>
                    {(Boolean(anxietyScoreWeek4) || anxietyScoreWeek4===0) && (
                        <div className="box space bold_text">
                            <span>{convertAnxietyScore(anxietyScoreWeek4)}</span>
                            <span>{anxietyScoreWeek4} 점</span>
                        </div>
                    )}
                </div>
            </div>
            <hr />
            <div className="title">목표 구체화하기<span className="sm_text">(8주 간의 여정이 끝난 뒤 되고 싶은 모습)</span></div>
            <div className="box">{eduGoal && eduGoal.goal}</div>
            <hr />
            <div className="title">4주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek4 && reviewListWeek4.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week4Edu06Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek4Edu06}>닫기</button>
        </div>
    )

    // Week5Edu03
    const [showWeek5Edu03, setShowWeek5Edu03] = useState(false);

    const closeWeek5Edu03 = () => {
        setShowWeek5Edu03(false);
    }

    const Week5Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek5.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek5}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek5 && <img className="fit_img" src={emotionImgWeek5} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
        </div>
    )
    const Week5Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek5Edu03}>닫기</button>
        </div>
    )

    // Week5Edu04
    const [showWeek5Edu04, setShowWeek5Edu04] = useState(false);

    const [showWeek5Edu04Record, setShowWeek5Edu04Record] = useState(false);
    const [selectedActivityDateString, setSelectedActivityDateString] = useState("");
    const [selectedActivityEmotionScore, setSelectedActivityEmotionScore] = useState(0);
    const [selectedActivityImpression, setSelectedActivityImpression] = useState("");

    const closeWeek5Edu04 = () => {
        setShowWeek5Edu04(false);
    }

    const closeWeek5Edu04Record = () => {
        setShowWeek5Edu04Record(false);
    }

    const handleClickShowActivityRecordWeek5 = ({date="", emotionScore=0, impression=""}) => {
        setSelectedActivityDateString(date);
        setSelectedActivityEmotionScore(emotionScore);
        setSelectedActivityImpression(impression);
        setShowWeek5Edu04Record(true);
    }

    const Week5Edu04RecordBody = (
        <div className="momthera_education_modal_body">
            <div className="box center bold_text round">{activityDetailWeek5 && activityDetailWeek5.activityName}</div>
            <div className="subtitle space half" style={{margin: '0.625rem 0'}}>
                <span>시간</span>
                <span style={{fontWeight: 400}}>{`${activityDetailWeek5 && activityDetailWeek5.activityTime ? activityDetailWeek5.activityTime.startTime : ""} - ${activityDetailWeek5 && activityDetailWeek5.activityTime ? activityDetailWeek5.activityTime.endTime : ""}`}</span>
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">장소</div>
                    <div className="box center">{activityDetailWeek5 && activityDetailWeek5.location}</div>
                </div>
                <div className="column">
                    <div className="subtitle">준비물</div>
                    <div className="box center">{activityDetailWeek5 && activityDetailWeek5.material}</div>
                </div>
            </div>
            <div className="subtitle">실천 가능성을 높이는 방법</div>
            <div className="box">
                {activityDetailWeek5 && activityDetailWeek5.increaseFeasibility.map(e=>(
                    <li key={e}>{e}</li>
                ))}
            </div>
            <div className="subtitle">감정</div>
            <div className="box center">
                <ActivityRecordEmotion emotionScore={selectedActivityEmotionScore} />
            </div>
            <div className="subtitle">소감</div>
            <div className="box h-175">{selectedActivityImpression}</div>
        </div>
    )

    const Week5Edu04RecordFooter = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek5Edu04Record}>닫기</button>
        </div>
    )

    const Week5Edu04Body = (
        <div className="momthera_education_modal_body">
            <div className="title">활동 계획하기</div>
            <div className="subtitle">선택활동 피라미드</div>
            <div className="box flexRow">
                <div className="row_wrapper">
                    <div className="activity_level">3단계</div>
                    <div className={`row_content activities ${(acitivities.levelThree && acitivities.levelThree.length > 0) ? '' : 'empty'}`}>
                        {(acitivities.levelThree && acitivities.levelThree.length > 0) ? acitivities.levelThree.map(e=>e.activityCode==='18' ? e.userDirectInput : e.activityName).join(', ') : "선택 없음"}
                    </div>
                </div>
                <div className="row_wrapper">
                    <div className="activity_level">2단계</div>
                    <div className={`row_content activities ${(acitivities.levelTwo && acitivities.levelTwo.length > 0) ? '' : 'empty'}`}>
                        {(acitivities.levelTwo && acitivities.levelTwo.length > 0) ? acitivities.levelTwo.map(e=>e.activityCode==='18' ? e.userDirectInput : e.activityName).join(', ') : "선택 없음"}
                    </div>
                </div>
                <div className="row_wrapper">
                    <div className="activity_level">1단계</div>
                    <div className={`row_content activities ${(acitivities.levelOne && acitivities.levelOne.length > 0) ? '' : 'empty'}`}>
                        {(acitivities.levelOne && acitivities.levelOne.length > 0) ? acitivities.levelOne.map(e=>e.activityCode==='18' ? e.userDirectInput : e.activityName).join(', ') : "선택 없음"}
                    </div>
                </div>
            </div>
            <div className="subtitle">활동 계획</div>
            <div className="box flexRow">
                <div className="row_wrapper">
                    <div className="row_label">목표 활동</div>
                    <div className="row_content">{activityDetailWeek5 && activityDetailWeek5.activityName}</div>
                </div>
                <div className="row_wrapper" style={{alignItems: 'flex-start'}}>
                    <div className="row_label">목표 활동 계획</div>
                    <div className="row_content activity_date_box">
                        <div className="activity_date_wrapper">
                            {activityDetailWeek5 && activityDetailWeek5.activityDateResponseList.map((e,idx)=>(
                                e.activityDate ? <div key={idx} className={`activity_date_item ${e.status ? 'plan' : ""} ${e.completionStatus ? 'complete' : ""}`}>
                                    <span>{`${e.activityDate.slice(4,6)}/${e.activityDate.slice(6)}`}</span>
                                    <span>{convertAtivityDateToDay(e.activityDate)}</span>
                                </div> : null
                            ))}
                        </div>
                        <hr />
                        <div className="activity_date_legend">
                            <div className="activity_date_legend_item">
                                <div className="activity_date_legend_icon_plan" />
                                <span>계획한 날</span>
                            </div>
                            <div className="activity_date_legend_item">
                                <div className="activity_date_legend_icon_complete" />
                                <span>수행한 날</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="subtitle">활동 기록지</div>
            <div className="box column-space-10">
                {activityDetailWeek5 && activityDetailWeek5.activityDateResponseList.map((e,idx)=>(
                    e.activityDate && e.status ? <div key={idx} className="activity_record_item">
                        <span className="date">
                            {`${e.activityDate.slice(0,4)}.${e.activityDate.slice(4,6)}.${e.activityDate.slice(6)} (${convertAtivityDateToDay(e.activityDate)}요일)`}
                        </span>
                        <button onClick={()=>handleClickShowActivityRecordWeek5({date: e.activityDate, emotionScore: e.emotionScore, impression: e.impression})}>자세히 보기</button>
                    </div> : null
                ))}                
            </div>
        </div>
    )
    const Week5Edu04Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek5Edu04}>닫기</button>
        </div>
    )

    // Week5Edu05
    const [showWeek5Edu05, setShowWeek5Edu05] = useState(false);

    const closeWeek5Edu05 = () => {
        setShowWeek5Edu05(false);
    }

    const Week5Edu05Body = (
        <div className="momthera_education_modal_body">
            <div className="title">5주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek5 && reviewListWeek5.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week5Edu05Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek5Edu05}>닫기</button>
        </div>
    )

    // Week6Edu03
    const [showWeek6Edu03, setShowWeek6Edu03] = useState(false);

    const closeWeek6Edu03 = () => {
        setShowWeek6Edu03(false);
    }

    const Week6Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek6.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek6}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek6 && <img className="fit_img" src={emotionImgWeek6} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
        </div>
    )
    const Week6Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek6Edu03}>닫기</button>
        </div>
    )

    // Week6Edu04
    const [showWeek6Edu04, setShowWeek6Edu04] = useState(false);

    const [showWeek6Edu04Record, setShowWeek6Edu04Record] = useState(false);

    const closeWeek6Edu04 = () => {
        setShowWeek6Edu04(false);
    }

    const closeWeek6Edu04Record = () => {
        setShowWeek6Edu04Record(false);
    }

    const handleClickShowActivityRecordWeek6 = ({date="", emotionScore=0, impression=""}) => {
        setSelectedActivityDateString(date);
        setSelectedActivityEmotionScore(emotionScore);
        setSelectedActivityImpression(impression);
        setShowWeek6Edu04Record(true);
    }

    const Week6Edu04RecordBody = (
        <div className="momthera_education_modal_body">
            <div className="box center bold_text round">{activityDetailWeek6 && activityDetailWeek6.activityName}</div>
            <div className="subtitle space half" style={{margin: '0.625rem 0'}}>
                <span>시간</span>
                <span style={{fontWeight: 400}}>{`${activityDetailWeek6 && activityDetailWeek6.activityTime ? activityDetailWeek6.activityTime.startTime : ""} - ${activityDetailWeek6 && activityDetailWeek6.activityTime ? activityDetailWeek6.activityTime.endTime : ""}`}</span>
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">장소</div>
                    <div className="box center">{activityDetailWeek6 && activityDetailWeek6.location}</div>
                </div>
                <div className="column">
                    <div className="subtitle">준비물</div>
                    <div className="box center">{activityDetailWeek6 && activityDetailWeek6.material}</div>
                </div>
            </div>
            <div className="subtitle">실천 가능성을 높이는 방법</div>
            <div className="box">
                {activityDetailWeek6 && activityDetailWeek6.increaseFeasibility.map(e=>(
                    <li key={e}>{e}</li>
                ))}
            </div>
            <div className="subtitle">감정</div>
            <div className="box center">
                <ActivityRecordEmotion emotionScore={selectedActivityEmotionScore} />
            </div>
            <div className="subtitle">소감</div>
            <div className="box h-175">{selectedActivityImpression}</div>
        </div>
    )

    const Week6Edu04RecordFooter = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek6Edu04Record}>닫기</button>
        </div>
    )

    const Week6Edu04Body = (
        <div className="momthera_education_modal_body">
            <div className="title">활동 계획하기</div>
            <div className="subtitle">우울을 극복하기 위한 방법</div>
            <div className="box">{overcome}</div>
            <div className="subtitle">선택활동 피라미드</div>
            <div className="box flexRow">
                <div className="row_wrapper" style={{alignItems: 'flex-start'}}>
                    <div className="activity_level">3단계</div>
                    <div className={`row_content activities activities_item_list ${(acitivities.levelThree && acitivities.levelThree.length > 0) ? '' : 'empty'}`}>
                        {(acitivities.levelThree && acitivities.levelThree.length > 0) ? acitivities.levelThree.map(e=> (
                            <div key={e.activityCode} className="activities_item">
                                <span>{e.activityCode==='18' ? e.userDirectInput : e.activityName}</span>
                                <span>{e.reason}</span>
                            </div>
                        )) : "선택 없음"}
                    </div>
                </div>
                <div className="row_wrapper" style={{alignItems: 'flex-start'}}>
                    <div className="activity_level">2단계</div>
                    <div className={`row_content activities activities_item_list ${(acitivities.levelTwo && acitivities.levelTwo.length > 0) ? '' : 'empty'}`}>
                        {(acitivities.levelTwo && acitivities.levelTwo.length > 0) ? acitivities.levelTwo.map(e=> (
                            <div key={e.activityCode} className="activities_item">
                                <span>{e.activityCode==='18' ? e.userDirectInput : e.activityName}</span>
                                <span>{e.reason}</span>
                            </div>
                        )) : "선택 없음"}
                    </div>
                </div>
                <div className="row_wrapper" style={{alignItems: 'flex-start'}}>
                    <div className="activity_level">1단계</div>
                    <div className={`row_content activities activities_item_list ${(acitivities.levelOne && acitivities.levelOne.length > 0) ? '' : 'empty'}`}>
                        {(acitivities.levelOne && acitivities.levelOne.length > 0) ? acitivities.levelOne.map(e=> (
                            <div key={e.activityCode} className="activities_item">
                                <span>{e.activityCode==='18' ? e.userDirectInput : e.activityName}</span>
                                <span>{e.reason}</span>
                            </div>
                        )) : "선택 없음"}
                    </div>
                </div>
            </div>
            <div className="subtitle">활동 계획</div>
            <div className="box flexRow">
                <div className="row_wrapper">
                    <div className="row_label">목표 활동</div>
                    <div className="row_content">{activityDetailWeek6 && activityDetailWeek6.activityName}{activityDetailWeek6 && searchActivityReason({targetCode: activityDetailWeek6.activityCode}) ? ` (${searchActivityReason({targetCode: activityDetailWeek6.activityCode})})` : ""}</div>
                </div>
                <div className="row_wrapper" style={{alignItems: 'flex-start'}}>
                    <div className="row_label">목표 활동 계획</div>
                    <div className="row_content activity_date_box">
                        <div className="activity_date_wrapper">
                            {activityDetailWeek6 && activityDetailWeek6.activityDateResponseList.map((e,idx)=>(
                                e.activityDate ? <div key={idx} className={`activity_date_item ${e.status ? 'plan' : ""} ${e.completionStatus ? 'complete' : ""}`}>
                                    <span>{`${e.activityDate.slice(4,6)}/${e.activityDate.slice(6)}`}</span>
                                    <span>{convertAtivityDateToDay(e.activityDate)}</span>
                                </div> : null
                            ))}
                        </div>
                        <hr />
                        <div className="activity_date_legend">
                            <div className="activity_date_legend_item">
                                <div className="activity_date_legend_icon_plan" />
                                <span>계획한 날</span>
                            </div>
                            <div className="activity_date_legend_item">
                                <div className="activity_date_legend_icon_complete" />
                                <span>수행한 날</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="subtitle">활동 기록지</div>
            <div className="box column-space-10">
                {activityDetailWeek6 && activityDetailWeek6.activityDateResponseList.map((e,idx)=>(
                    e.activityDate && e.status ? <div key={idx} className="activity_record_item">
                        <span className="date">
                            {`${e.activityDate.slice(0,4)}.${e.activityDate.slice(4,6)}.${e.activityDate.slice(6)} (${convertAtivityDateToDay(e.activityDate)}요일)`}
                        </span>
                        <button onClick={()=>handleClickShowActivityRecordWeek6({date: e.activityDate, emotionScore: e.emotionScore, impression: e.impression})}>자세히 보기</button>
                    </div> : null
                ))}                
            </div>
        </div>
    )
    const Week6Edu04Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek6Edu04}>닫기</button>
        </div>
    )

    // Week6Edu06
    const [showWeek6Edu06, setShowWeek6Edu06] = useState(false);

    const closeWeek6Edu06 = () => {
        setShowWeek6Edu06(false);
    }

    const Week6Edu06Body = (
        <div className="momthera_education_modal_body">
            <div className="title">6주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek6 && reviewListWeek6.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week6Edu06Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek6Edu06}>닫기</button>
        </div>
    )
    
    // Week7Edu03
    const [showWeek7Edu03, setShowWeek7Edu03] = useState(false);

    const closeWeek7Edu03 = () => {
        setShowWeek7Edu03(false);
    }

    const Week7Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek7.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek7}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek7 && <img className="fit_img" src={emotionImgWeek7} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
        </div>
    )
    const Week7Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek7Edu03}>닫기</button>
        </div>
    )
    
    // Week7Edu03
    const [showWeek7Edu04, setShowWeek7Edu04] = useState(false);

    const closeWeek7Edu04 = () => {
        setShowWeek7Edu04(false);
    }

    const Week7Edu04Body = (
        <div className="momthera_education_modal_body">
            <div className="title">즐거움과 성취감을 느끼는 활동</div>
            <div className="column_wrapper" style={{marginBottom: '1.25rem'}}>
                <div className="column">
                    <div className="box h-175 assessment_box">
                        <div className="assessment_title">항우울 효과를 지닌 활동은?</div>
                        {assessment && assessment.positiveActivities.map((e,idx)=>(
                            <li key={idx}>{e}</li>
                        ))}
                    </div>
                </div>
                <div className="column">
                    <div className="box h-175 assessment_box">
                        <div className="assessment_title">항우울 활동을 지속하는 데 도움 되는 것은?</div>
                        {assessment && assessment.sustainingFactors.map((e,idx)=>(
                            <li key={idx}>{e}</li>
                        ))}
                    </div>
                </div>
            </div>
            <div className="title">우울이 지속되게 하는 활동</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="box h-175 assessment_box">
                        <div className="assessment_title">우울에 취약한 상황은?</div>
                        {assessment && assessment.vulnerableSituations.map((e,idx)=>(
                            <li key={idx}>{e}</li>
                        ))}
                    </div>
                </div>
                <div className="column">
                    <div className="box h-175 assessment_box">
                        <div className="assessment_title">계속 우울하게 만드는 나의 행동은?</div>
                        {assessment && assessment.negativeBehaviors.map((e,idx)=>(
                            <li key={idx}>{e}</li>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
    const Week7Edu04Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek7Edu04}>닫기</button>
        </div>
    )

    // Week7Edu06
    const [showWeek7Edu06, setShowWeek7Edu06] = useState(false);

    const closeWeek7Edu06 = () => {
        setShowWeek7Edu06(false);
    }

    const Week7Edu06Body = (
        <div className="momthera_education_modal_body">
            <div className="title">7주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek7 && reviewListWeek7.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week7Edu06Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek7Edu06}>닫기</button>
        </div>
    )

    // Week8Edu03
    const [showWeek8Edu03, setShowWeek8Edu03] = useState(false);

    const closeWeek8Edu03 = () => {
        setShowWeek8Edu03(false);
    }

    const Week8Edu03Body = (
        <div className="momthera_education_modal_body">
            <div className="title">기분 상태 점검</div>
            <div className="subtitle">감정</div>
            <div className="box flexRow">
                {emotionListWeek8.map(emotion => (
                    <div key={emotion.emotionName} className="halfBox">
                        <span>{emotion.emotionName}</span>
                        <span>{emotion.score} / 100 점</span>
                    </div>
                ))}
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">메모</div>
                    <div className="box h-175">{emotionMemoWeek8}</div>
                </div>
                <div className="column">
                    <div className="subtitle">사진</div>
                    <div className="box h-175">
                        {emotionImgWeek8 && <img className="fit_img" src={emotionImgWeek8} alt="week1 edu06 emotion"/>}
                    </div>
                </div>
            </div>
            <hr/>
            <div className="title">처음에 선택한 감정 중 줄어들거나 사라진 감정</div>
            <div className="box bold_text" style={{textAlign: 'left'}}>{lostEmotion && lostEmotion.join(", ")}</div>
        </div>
    )
    const Week8Edu03Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek8Edu03}>닫기</button>
        </div>
    )

    // Week8Edu01
    const [showWeek8Edu01, setShowWeek8Edu01] = useState(false);

    const closeWeek8Edu01 = () => {
        setShowWeek8Edu01(false);
    }

    const Week8Edu01Body = (
        <div className="momthera_education_modal_body">
            <div className="title">나에게 편지 쓰기</div>
            <div className="subtitle">편지 내용</div>
            <div className="box">{letter && letter.content}</div>
            <div className="subtitle">이완 훈련을 {patientData.name} 님의 삶에 적용하기 위한 간단한 계획 & 다짐</div>
            <div className="box">{letter && letter.commitmentPlan}</div>
        </div>
    )
    const Week8Edu01Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek8Edu01}>닫기</button>
        </div>
    )

    // Week8Edu03
    const [showWeek8Edu05, setShowWeek8Edu05] = useState(false);

    const closeWeek8Edu05 = () => {
        setShowWeek8Edu05(false);
    }

    const Week8Edu05Body = (
        <div className="momthera_education_modal_body">
            <div className="title">{patientData.name} 님의 대처방안</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">가장 도움이 되었던 치료방법</div>
                    <div className="box h-175 center">
                        <div>{responsePlan && responsePlan.theraTypeName}</div>
                        <div>{responsePlan && responsePlan.theraTypeSubtopicName}</div>
                    </div>
                </div>
                <div className="column">
                    <div className="subtitle">사용자 작성</div>
                    <div className="box h-175">{responsePlan && responsePlan.userPlan}</div>
                </div>
            </div>
        </div>
    )
    const Week8Edu05Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek8Edu05}>닫기</button>
        </div>
    )

    // Week8Edu06
    const [showWeek8Edu06, setShowWeek8Edu06] = useState(false);

    const closeWeek8Edu06 = () => {
        setShowWeek8Edu06(false);
    }

    const Week8Edu06Body = (
        <div className="momthera_education_modal_body">
            <div className="title">8주 마무리하기</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">4주차에 작성했던 목표</div>
                    <div className="box h-175">{eduGoal && eduGoal.goal}</div>
                </div>
                <div className="column">
                    <div className="subtitle">4주차에 작성했던 목표에 대한 감상(점수)</div>
                    <div className="box h-175 center">
                        <ActivityRecordEmotion type={"eduGoal"} emotionScore={eduGoal.emotionLevel} />
                    </div>
                </div>
            </div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">지금 이 순간 기록하기</div>
                    <div className="box h-175">
                        {eduGoalImg && <img className="fit_img" src={eduGoalImg} alt="edu goal" />}
                    </div>
                </div>
            </div>
            <hr />
            <div className="title">우울 및 불안 점수</div>
            <div className="column_wrapper">
                <div className="column">
                    <div className="subtitle">우울 점수</div>
                    {(Boolean(depressionScoreWeek8) || depressionScoreWeek8===0) && (
                        <div className="box space">
                            <span>{convertDepressionScore(depressionScoreWeek8)}</span>
                            <span>{depressionScoreWeek8} 점</span>
                        </div>
                    )}
                </div>
                <div className="column">
                    <div className="subtitle">불안 점수</div>
                    {(Boolean(anxietyScoreWeek8) || anxietyScoreWeek8===0) && (
                        <div className="box space">
                            <span>{convertAnxietyScore(anxietyScoreWeek8)}</span>
                            <span>{anxietyScoreWeek8} 점</span>
                        </div>
                    )}
                </div>
            </div>
            <hr />
            <div className="title">8주차 후기</div>
            <div className="column-space-10">
                {reviewListWeek8 && reviewListWeek8.map((review, idx)=>(
                    <div key={idx} className="box h-175">
                        <div className="header">
                            <div className="secretmode">{review.date ? `${review.secretMode ? "비공개" : "전체 공개"}` : ""}</div>
                            <div className="insdate">{review.date}</div>
                        </div>
                        {review.memo}
                    </div>
                ))}
            </div>
        </div>
    )
    const Week8Edu06Footer = (
        <div className="momthera_education_modal_footer">
            <button onClick={closeWeek8Edu06}>닫기</button>
        </div>
    )

    // 환자가 작성하는 데이터가 있는 교육 리스트 (작성 확인 버튼)
    const EXIST_CONTENT_LIST = [
        // 1주차
        { sessionNum: 1, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek1Edu03(true)},
        { sessionNum: 1, theraTypeCode: '02', theraTypeSubtopicNum: 4, handleClick: ()=>setShowWeek1Edu02(true)},
        { sessionNum: 1, theraTypeCode: '06', theraTypeSubtopicNum: 5, handleClick: ()=>setShowWeek1Edu06(true)},
        // 2주차
        { sessionNum: 2, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek2Edu03(true)},
        { sessionNum: 2, theraTypeCode: '02', theraTypeSubtopicNum: 3, handleClick: ()=>setShowWeek2Edu02(true)},
        { sessionNum: 2, theraTypeCode: '06', theraTypeSubtopicNum: 4, handleClick: ()=>setShowWeek2Edu06(true)},
        // 3주차
        { sessionNum: 3, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek3Edu03(true)},
        { sessionNum: 3, theraTypeCode: '01', theraTypeSubtopicNum: 2, handleClick: ()=>setShowWeek3Edu01(true)},
        { sessionNum: 3, theraTypeCode: '02', theraTypeSubtopicNum: 3, handleClick: ()=>setShowWeek3Edu02(true)},
        { sessionNum: 3, theraTypeCode: '06', theraTypeSubtopicNum: 5, handleClick: ()=>setShowWeek3Edu06(true)},
        // 4주차
        { sessionNum: 4, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek4Edu03(true)},
        { sessionNum: 4, theraTypeCode: '02', theraTypeSubtopicNum: 4, handleClick: ()=>setShowWeek4Edu02(true)},
        { sessionNum: 4, theraTypeCode: '06', theraTypeSubtopicNum: 6, handleClick: ()=>setShowWeek4Edu06(true)},
        // 5주차
        { sessionNum: 5, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek5Edu03(true)},
        { sessionNum: 5, theraTypeCode: '04', theraTypeSubtopicNum: 3, handleClick: ()=>setShowWeek5Edu04(true)},
        { sessionNum: 5, theraTypeCode: '06', theraTypeSubtopicNum: 5, handleClick: ()=>setShowWeek5Edu05(true)},
        // 6주차
        { sessionNum: 6, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek6Edu03(true)},
        { sessionNum: 6, theraTypeCode: '04', theraTypeSubtopicNum: 3, handleClick: ()=>setShowWeek6Edu04(true)},
        { sessionNum: 6, theraTypeCode: '06', theraTypeSubtopicNum: 6, handleClick: ()=>setShowWeek6Edu06(true)},
        // 7주차
        { sessionNum: 7, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek7Edu03(true)},
        { sessionNum: 7, theraTypeCode: '04', theraTypeSubtopicNum: 3, handleClick: ()=>setShowWeek7Edu04(true)},
        { sessionNum: 7, theraTypeCode: '06', theraTypeSubtopicNum: 5, handleClick: ()=>setShowWeek7Edu06(true)},
        // 8주차
        { sessionNum: 8, theraTypeCode: '03', theraTypeSubtopicNum: 1, handleClick: ()=>setShowWeek8Edu03(true)},
        { sessionNum: 8, theraTypeCode: '01', theraTypeSubtopicNum: 2, handleClick: ()=>setShowWeek8Edu01(true)},
        { sessionNum: 8, theraTypeCode: '05', theraTypeSubtopicNum: 3, handleClick: ()=>setShowWeek8Edu05(true)},
        { sessionNum: 8, theraTypeCode: '06', theraTypeSubtopicNum: 4, handleClick: ()=>setShowWeek8Edu06(true)},
    ]

    useEffect(()=>{
        getDecisionReasonMemoFromAPI();
        getDecisionReasonImageFromAPI();
        getEmotionBaseFromAPI();
        getDistortionBaseFromAPI();
        getGroundingCalmFromAPI();
        getEduGoalFromAPI();
        getEduGoalImgFromAPI();
        getActivitiesFromAPI();
        getOvercomeFromAPI();
        getActivitiesAssessmentFromAPI();
        getLostEmotionFromAPI();
        getLetterFromAPI();
        getResponsePlanFromAPI();
        // 1주차
        getAutothinkSessionWeek1FromAPI();
        getEmotionImgFromAPI({sessionNum: 1, setState: setEmotionImgWeek1});
        getReviewFromAPI(1, setReviewListWeek1);
        // 2주차
        getEmotionImgFromAPI({sessionNum: 2, setState: setEmotionImgWeek2});
        getAutothinkSessionWeek2FromAPI();
        getReviewFromAPI(2, setReviewListWeek2);
        getGroundingComfortableFromAPI({targetSession: 2, setState: setComfortableWeek2});
        // 3주차
        getEmotionImgFromAPI({sessionNum: 3, setState: setEmotionImgWeek3});
        getAutothinkSessionWeek3FromAPI();
        getReviewFromAPI(3, setReviewListWeek3);
        getGroundingComfortableFromAPI({targetSession: 3, setState: setComfortableWeek3});
        // 4주차
        getEmotionImgFromAPI({sessionNum: 4, setState: setEmotionImgWeek4});
        getAutothinkSessionWeek4FromAPI();
        getReviewFromAPI(4, setReviewListWeek4);
        getGroundingComfortableFromAPI({targetSession: 4, setState: setComfortableWeek4});
        // 5주차
        getEmotionImgFromAPI({sessionNum: 5, setState: setEmotionImgWeek5});
        getActivityDetailFromAPI({targetSession: 5, setState: setActivityDetailWeek5});
        getReviewFromAPI(5, setReviewListWeek5);
        getGroundingComfortableFromAPI({targetSession: 5, setState: setComfortableWeek5});
        // 6주차
        getEmotionImgFromAPI({sessionNum: 6, setState: setEmotionImgWeek6});
        getActivityDetailFromAPI({targetSession: 6, setState: setActivityDetailWeek6});
        getReviewFromAPI(6, setReviewListWeek6);
        getGroundingComfortableFromAPI({targetSession: 6, setState: setComfortableWeek6});
        // 7주차
        getEmotionImgFromAPI({sessionNum: 7, setState: setEmotionImgWeek7});
        getReviewFromAPI(7, setReviewListWeek7);
        getGroundingComfortableFromAPI({targetSession: 7, setState: setComfortableWeek7});
        // 8주차
        getEmotionImgFromAPI({sessionNum: 8, setState: setEmotionImgWeek8});
        getReviewFromAPI(8, setReviewListWeek8);
    },[])
    /* 감정 데이터 매핑 */
    useEffect(()=>{
        // 1주차
        mappingEmotionList(1, setEmotionListWeek1);
        mappingEmotionMemo(1, setEmotionMemoWeek1);
        // 2주차
        mappingEmotionList(2, setEmotionListWeek2);
        mappingEmotionMemo(2, setEmotionMemoWeek2);
        // 3주차
        mappingEmotionList(3, setEmotionListWeek3);
        mappingEmotionMemo(3, setEmotionMemoWeek3);
        // 4주차
        mappingEmotionList(4, setEmotionListWeek4);
        mappingEmotionMemo(4, setEmotionMemoWeek4);
        // 5주차
        mappingEmotionList(5, setEmotionListWeek5);
        mappingEmotionMemo(5, setEmotionMemoWeek5);
        // 6주차
        mappingEmotionList(6, setEmotionListWeek6);
        mappingEmotionMemo(6, setEmotionMemoWeek6);
        // 7주차
        mappingEmotionList(7, setEmotionListWeek7);
        mappingEmotionMemo(7, setEmotionMemoWeek7);
        // 8주차
        mappingEmotionList(8, setEmotionListWeek8);
        mappingEmotionMemo(8, setEmotionMemoWeek8);
    },[emotionData])
    /* 우울 검사 데이터 매핑 */
    useEffect(()=>{
        // 1주차
        mappingDepressionScore(1, setDepressionScoreWeek1);
        // 4주차
        mappingDepressionScore(4, setDepressionScoreWeek4);
        // 8주차
        mappingDepressionScore(8, setDepressionScoreWeek8);

    },[depressionData])
    /* 불안 검사 데이터 매핑 */
    useEffect(()=>{
        // 1주차
        mappingAnxietyScore(1, setAnxietyScoreWeek1);
        // 4주차
        mappingAnxietyScore(4, setAnxietyScoreWeek4);
        // 8주차
        mappingAnxietyScore(8, setAnxietyScoreWeek8);
    },[anxietyData])

    useEffect(()=>{
        setOnGoingSession(patientData.studySession);
        if(patientData.studySession){
            setSelectedSession(patientData.studySession>8 ? 8 : patientData.studySession);
        }else{
            setSelectedSession(1);
        }
    },[patientData])

    useEffect(()=>{
        getEduStatusFromAPI({sessionNum: selectedSession});
    },[selectedSession])
    

    return (
        <div className="patientResult__education momthera">
            <div className="education_session momthera" style={{height: 'auto'}}>
                {[1,2,3,4,5,6,7,8].map(e=>(
                    <div key={e} className="education_session_item">
                        <button
                            className={`education_session_circle momthera ${e <= onGoingSession ? "bold-border" : ""} ${e===selectedSession ? "selected" : ""}`}
                            onClick={()=>setSelectedSession(e)}
                        >{e}주차</button>
                        {e<onGoingSession && e!==8 && <div className="education_session_bar" />}
                        {e>=onGoingSession && e!==8 && (
                            <div className="education_session_bar_dot">
                                <div className="dot" />
                                <div className="dot" />
                                <div className="dot" />
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className="momthera_education_content">
                {selectedSession===1 && <Week1Section depressionScoreWeek1={depressionScoreWeek1} anxietyScoreWeek1={anxietyScoreWeek1} emotionListWeek1={emotionListWeek1} />}
                {selectedSession===2 && <Week2Section emotionListWeek2={emotionListWeek2} comfortableWeek2={comfortableWeek2} />}
                {selectedSession===3 && <Week3Section emotionListWeek3={emotionListWeek3} comfortableWeek3={comfortableWeek3} />}
                {selectedSession===4 && <Week4Section emotionListWeek4={emotionListWeek4} depressionScoreWeek4={depressionScoreWeek4} anxietyScoreWeek4={anxietyScoreWeek4} comfortableWeek4={comfortableWeek4} />}
                {selectedSession===5 && <Week5Section emotionListWeek5={emotionListWeek5} comfortableWeek5={comfortableWeek5} />}
                {selectedSession===6 && <Week6Section emotionListWeek6={emotionListWeek6} comfortableWeek6={comfortableWeek6} />}
                {selectedSession===7 && <Week7Section emotionListWeek7={emotionListWeek7} comfortableWeek7={comfortableWeek7} />}
                {selectedSession===8 && <Week8Section emotionListWeek8={emotionListWeek8} depressionScoreWeek8={depressionScoreWeek8} anxietyScoreWeek8={anxietyScoreWeek8} />}
                <div className="momthera_education_right_section">
                    <div className="title" style={{marginBottom: '0.625rem'}}>{selectedSession}주차 교육 현황</div>
                    <table className="momthera_education_table">
                        <thead>
                            <tr>
                                {TABLE_HEADER.map(item=>(
                                    <th key={item.key}>{item.name}</th>
                                ))}
                            </tr>
                            {eduStatusData.map((data, idx) => (
                                <tr key={idx}>
                                    {TABLE_HEADER.slice(0,-1).map(item => (
                                        <td key={item.key}>
                                            {item.key==='status' ? convertEduStatus(data[item.key]) : data[item.key]}
                                        </td>
                                    ))}
                                    <td>
                                        <button
                                            className="momthera_education_table_contentBtn"
                                            disabled={data.status!=='COMPLETE' || (EXIST_CONTENT_LIST.filter(e=> e.sessionNum===selectedSession && e.theraTypeCode===data.theraTypeCode && e.theraTypeSubtopicNum===data.theraTypeSubtopicNum).length===0)}
                                            onClick={() => {
                                                if(EXIST_CONTENT_LIST.filter(e=>e.sessionNum===selectedSession && e.theraTypeCode===data.theraTypeCode && e.theraTypeSubtopicNum===data.theraTypeSubtopicNum).length>0){
                                                    EXIST_CONTENT_LIST.filter(e=>e.sessionNum===selectedSession && e.theraTypeCode===data.theraTypeCode && e.theraTypeSubtopicNum===data.theraTypeSubtopicNum)[0].handleClick();
                                                }
                                            }}
                                        >
                                            {(EXIST_CONTENT_LIST.filter(e=>e.sessionNum===selectedSession && e.theraTypeCode===data.theraTypeCode && e.theraTypeSubtopicNum===data.theraTypeSubtopicNum).length>0) ? '작성 확인' : '환자 작성 없음'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            <tr />
                        </tbody>
                    </table>
                </div>
            </div>
            {/* week 1 */}
            <CommonModal
                header="[심리교육] 현재 상태 점검"
                body={Week1Edu03Body}
                footer={Week1Edu03Footer}
                show={showWeek1Edu03}
                setClose={closeWeek1Edu03}
                size='lg'
            />
            <CommonModal
                header="[인지재구성] 자동적 사고"
                body={Week1Edu02Body}
                footer={Week1Edu02Footer}
                show={showWeek1Edu02}
                setClose={closeWeek1Edu02}
                size='lg'
            />     
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week1Edu06Body}
                footer={Week1Edu06Footer}
                show={showWeek1Edu06}
                setClose={closeWeek1Edu06}
                size='lg'
            />
            {/* week 2 */}
            <CommonModal
                header="[심리교육] 기분 상태 점검"
                body={Week2Edu03Body}
                footer={Week2Edu03Footer}
                show={showWeek2Edu03}
                setClose={closeWeek2Edu03}
                size='lg'
            />
            <CommonModal
                header="[인지재구성] 자동적 사고"
                body={Week2Edu02Body}
                footer={Week2Edu02Footer}
                show={showWeek2Edu02}
                setClose={closeWeek2Edu02}
                size='lg'
            />
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week2Edu06Body}
                footer={Week2Edu06Footer}
                show={showWeek2Edu06}
                setClose={closeWeek2Edu06}
                size='lg'
            />
            {/* week 3 */}
            <CommonModal
                header="[심리교육] 기분 상태 점검"
                body={Week3Edu03Body}
                footer={Week3Edu03Footer}
                show={showWeek3Edu03}
                setClose={closeWeek3Edu03}
                size='lg'
            />
            <CommonModal
                header="[이완훈련] 진정형 그라운딩"
                body={Week3Edu01Body}
                footer={Week3Edu01Footer}
                show={showWeek3Edu01}
                setClose={closeWeek3Edu01}
                size='lg'
            />
            <CommonModal
                header="[인지재구성] 자동적 사고 다루기"
                body={Week3Edu02Body}
                footer={Week3Edu02Footer}
                show={showWeek3Edu02}
                setClose={closeWeek3Edu02}
                size='lg'
            />
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week3Edu06Body}
                footer={Week3Edu06Footer}
                show={showWeek3Edu06}
                setClose={closeWeek3Edu06}
                size='lg'
            />
            {/* week 4 */}
            <CommonModal
                header="[심리교육] 기분 상태 점검"
                body={Week4Edu03Body}
                footer={Week4Edu03Footer}
                show={showWeek4Edu03}
                setClose={closeWeek4Edu03}
                size='lg'
            />
            <CommonModal
                header="[인지재구성] 유연한 사고로 나아가기"
                body={Week4Edu02Body}
                footer={Week4Edu02Footer}
                show={showWeek4Edu02}
                setClose={closeWeek4Edu02}
                size='lg'
            />
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week4Edu06Body}
                footer={Week4Edu06Footer}
                show={showWeek4Edu06}
                setClose={closeWeek4Edu06}
                size='lg'
            />
            {/* week 5 */}
            <CommonModal
                header="[심리교육] 기분 상태 점검"
                body={Week5Edu03Body}
                footer={Week5Edu03Footer}
                show={showWeek5Edu03}
                setClose={closeWeek5Edu03}
                size='lg'
            />
            <CommonModal
                header="[행동활성화] 생각, 감정 그리고 행동"
                body={Week5Edu04Body}
                footer={Week5Edu04Footer}
                show={showWeek5Edu04}
                setClose={closeWeek5Edu04}
                size='lg'
            />
            <CommonModal
                header={`활동기록지(${selectedActivityDateString.slice(0,4)}.${selectedActivityDateString.slice(4,6)}.${selectedActivityDateString.slice(6)})`}
                body={Week5Edu04RecordBody}
                footer={Week5Edu04RecordFooter}
                show={showWeek5Edu04Record}
                setClose={closeWeek5Edu04Record}
                size='lg'
            />
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week5Edu05Body}
                footer={Week5Edu05Footer}
                show={showWeek5Edu05}
                setClose={closeWeek5Edu05}
                size='lg'
            />
            {/* week 6 */}
            <CommonModal
                header="[심리교육] 기분 상태 점검"
                body={Week6Edu03Body}
                footer={Week6Edu03Footer}
                show={showWeek6Edu03}
                setClose={closeWeek6Edu03}
                size='lg'
            />
            <CommonModal
                header="[행동활성화] 활동 계획 수정하기"
                body={Week6Edu04Body}
                footer={Week6Edu04Footer}
                show={showWeek6Edu04}
                setClose={closeWeek6Edu04}
                size='lg'
            />
            <CommonModal
                header={`활동기록지(${selectedActivityDateString.slice(0,4)}.${selectedActivityDateString.slice(4,6)}.${selectedActivityDateString.slice(6)})`}
                body={Week6Edu04RecordBody}
                footer={Week6Edu04RecordFooter}
                show={showWeek6Edu04Record}
                setClose={closeWeek6Edu04Record}
                size='lg'
            />
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week6Edu06Body}
                footer={Week6Edu06Footer}
                show={showWeek6Edu06}
                setClose={closeWeek6Edu06}
                size='lg'
            />
            {/* week 7 */}
            <CommonModal
                header="[심리교육] 기분 상태 점검"
                body={Week7Edu03Body}
                footer={Week7Edu03Footer}
                show={showWeek7Edu03}
                setClose={closeWeek7Edu03}
                size='lg'
            />
            <CommonModal
                header="[행동활성화] 항우울 행동 지속하기"
                body={Week7Edu04Body}
                footer={Week7Edu04Footer}
                show={showWeek7Edu04}
                setClose={closeWeek7Edu04}
                size='lg'
            />
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week7Edu06Body}
                footer={Week7Edu06Footer}
                show={showWeek7Edu06}
                setClose={closeWeek7Edu06}
                size='lg'
            />
            {/* week 8 */}
            <CommonModal
                header="[심리교육] 기분 상태 점검"
                body={Week8Edu03Body}
                footer={Week8Edu03Footer}
                show={showWeek8Edu03}
                setClose={closeWeek8Edu03}
                size='lg'
            />
            <CommonModal
                header="[이완훈련] 스스로에게 친절하기"
                body={Week8Edu01Body}
                footer={Week8Edu01Footer}
                show={showWeek8Edu01}
                setClose={closeWeek8Edu01}
                size='lg'
            />
            <CommonModal
                header="[마음챙김]  재발 위험신호 알아차리기"
                body={Week8Edu05Body}
                footer={Week8Edu05Footer}
                show={showWeek8Edu05}
                setClose={closeWeek8Edu05}
                size='lg'
            />
            <CommonModal
                header="[마무리하기] 마무리하기"
                body={Week8Edu06Body}
                footer={Week8Edu06Footer}
                show={showWeek8Edu06}
                setClose={closeWeek8Edu06}
                size='lg'
            />
        </div>
    );
}

export default MomtheraEducation;